var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcppStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 0.333252H1.66671C0.933374 0.333252 0.340041 0.933252 0.340041 1.66659L0.333374 13.6666L3.00004 10.9999H12.3334C13.0667 10.9999 13.6667 10.3999 13.6667 9.66658V1.66659C13.6667 0.933252 13.0667 0.333252 12.3334 0.333252ZM10.3334 8.33325H3.66671C3.30004 8.33325 3.00004 8.03325 3.00004 7.66658C3.00004 7.29992 3.30004 6.99992 3.66671 6.99992H10.3334C10.7 6.99992 11 7.29992 11 7.66658C11 8.03325 10.7 8.33325 10.3334 8.33325ZM10.3334 6.33325H3.66671C3.30004 6.33325 3.00004 6.03325 3.00004 5.66658C3.00004 5.29992 3.30004 4.99992 3.66671 4.99992H10.3334C10.7 4.99992 11 5.29992 11 5.66658C11 6.03325 10.7 6.33325 10.3334 6.33325ZM10.3334 4.33325H3.66671C3.30004 4.33325 3.00004 4.03325 3.00004 3.66658C3.00004 3.29992 3.30004 2.99992 3.66671 2.99992H10.3334C10.7 2.99992 11 3.29992 11 3.66658C11 4.03325 10.7 4.33325 10.3334 4.33325Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcppStatus);
export default __webpack_public_path__ + "static/media/ocppStatus.69cd4ad71829e2610a825349654ef364.svg";
export { ForwardRef as ReactComponent };